import React, { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button, Col, Container, Form, FormFeedback, Input, Row, Label, Card, CardBody, CardText } from 'reactstrap'
import { useFormik } from "formik";
import * as Yup from "yup";
import { FORM_MESSAGES } from "constants/app.constants";
import 'flatpickr/dist/themes/material_green.css';
import Select from 'react-select';
import { isEmpty } from 'lodash';
import { addNonDealerInquiryRemarks, getOneNonRegisterDealer, updateNonDealerProductInquiryStatus } from 'helpers/UAM/inquiry.helper';
import moment from 'moment';
import ToastDialog from 'common/ToastDialog';

import { SystemConfigurationContext } from 'context/systemConfigContext';
import ConfirmationModal from 'components/Common/ConfirmationModal';
import { v4 as uuidv4 } from 'uuid';

import { formatNumberWithCommas } from '../../common/utility'
const EditUserInquiry = () => {

    document.title="Edit Non Registered Dealer Inquiry | DMS"
    const [isBtnLoading, setIsBtnLoading] = useState(false)
    const [toastInfo, setToastInfo] = useState({ showToast: false });
    const [inquiryInfo, setInquiryInfo] = useState({});
    const [confirmationStatus, setConfirmationStatus] = useState(null);
    const { inputMax } = useContext(SystemConfigurationContext)

    const navigate = useNavigate()
    let { inqId } = useParams();

    let decodedInqId = atob(inqId)

    const {roleName}= JSON.parse(localStorage.getItem("user"))

    const statusOptions = [
        { value: 'pending', label: 'Pending' },
        { value: 'win', label: 'Closed (Win)' },
        { value: 'lost', label: 'Closed (Lost)' },
    ]

    const handleFormSubmit = async (values) => {
        setIsBtnLoading(true)
        const bodyData = {
            id: inquiryInfo.id,
            remarks: values.remarks,
        }
        const res = await addNonDealerInquiryRemarks(bodyData);
        if (res.status) {
            formik.resetForm()
            getInquiryInfo()
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
        setIsBtnLoading(false)
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            remarks: '',
        },
        validationSchema: Yup.object({
            remarks: Yup.string().required(FORM_MESSAGES.REQUIRED),
        }),
        onSubmit: async (values) => {
            handleFormSubmit(values)
        },
    });

    async function getInquiryInfo() {
        const res = await getOneNonRegisterDealer({ inqId: decodedInqId })
        if (res.status) {
            setInquiryInfo(res.data)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    useEffect(() => {
        getInquiryInfo()
    }, [])

    const ProductDescription = ({ desc = "" }) => {
        let descLength = desc.length

        const [showReadMore, setShowReadMore] = useState(descLength > 150);

        let descToShow = desc.substring(0, 150);
        let descToHide = desc.substring(150, descLength);

        const handleReadMore = () => {
            setShowReadMore(false);
        }

        const handleReadLess = () => {
            setShowReadMore(true);
        }


        return (
            <p>
                {showReadMore ? descToShow : descToShow + descToHide} {" "}
                {showReadMore && (
                    <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadMore}>
                        ...Read More
                    </span>
                )}
                {descLength > 150 && (!showReadMore) && (
                    <span style={{ cursor: 'pointer' }} className="read-more-link  text-decoration-underline" onClick={handleReadLess}>
                        Read Less
                    </span>
                )}
            </p>
        )
    }

    const handleStatus = (option) => {
        setConfirmationStatus(option.value)
    }

    const handleStatusChange = async (status) => {
        const bodyData = {
            inqId: decodedInqId,
            productStatus: status
        }

        const res = await updateNonDealerProductInquiryStatus(bodyData);
        if (res.status) {
            setToastInfo({ message: res.message, showToast: true, role: "success" });
            setInquiryInfo(prevInfo => {
                return { ...prevInfo, productStatus: status }
            })
            setConfirmationStatus(null)
        } else {
            setToastInfo({ message: res.message, showToast: true, role: "error" });
        }
    }

    const bgStyle = {
        background: '#fff',
        boxShadow: '0 1px 4px #344fa0',
        borderRadius: '10px',
        marginTop: '10px'
    }

    const bgStyleReply = {
        background: '#fff',
        boxShadow: '0 1px 4px #ccc',
        borderRadius: '10px',
        marginTop: '10px'
    }
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div className="page-title-box pb-2 d-flex gap-3 justify-content-between align-items-center mb-1 w-100">

                        {/* <i role='button' onClick={() => navigate('/admin/inquiry')} className='bx bx-arrow-back me-3'></i> */}
                        <h4 className='mb-0'>Edit Non Registered Dealer Inquiry</h4>
                        <div>
                            <button
                                className="btn btn-outline-secondary"
                                type="button"
                                onClick={() => navigate(`/${roleName}/inquiry`)}
                            >
                                Back
                            </button>
                        </div>

                        {/* <i role='button' onClick={() => handleShowInfo(inquiryInfo)} className='bx bx-dots-horizontal-rounded font-24 d-sm-none d-block'></i> */}
                    </div>
                    {/* <hr className='h-10' /> */}


                    <Row className='g-2'>
                        <Col sm={12} md={12} lg={12} xl={12} className='card'>
                            <div className='card-body p-4'>
                                <Row>
                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Inquiry Number</Label>
                                        <p className="">INQ-{inquiryInfo.inquiryNumber}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Person Name</Label>
                                        <p className="">{inquiryInfo.fullName}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Expected Delivery Date</Label>
                                        <p className="">{!isEmpty(inquiryInfo.deliveryDate) ? moment(inquiryInfo.deliveryDate).format('MMM DD, YYYY') : ''}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Quantity</Label>
                                        <p className="">{inquiryInfo.quantity}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Expected Price Per Unit</Label>
                                        <p className="">{formatNumberWithCommas(+inquiryInfo.price)}</p>
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Product Description</Label>
                                        <ProductDescription desc={inquiryInfo.productDescription} />
                                    </div>

                                    <div className="col-3 mb-3">
                                        <Label className="form-label">Status</Label>
                                        <Select
                                            options={statusOptions}
                                            className='select2-container select2-container--default'
                                            classNamePrefix="select2-selection"
                                            value={statusOptions.find(obj => obj.value === inquiryInfo.productStatus)}
                                            isDisabled={inquiryInfo.productStatus == 'win' || inquiryInfo.productStatus == 'lost'}
                                            onChange={(e) => {
                                                handleStatus(e)
                                            }}
                                        />
                                    </div>

                                </Row>
                            </div>
                        </Col>

                        <Col sm={6} md={6} lg={6} xl={6} className='card'>
                            <Row className="timeline card-body pb-0">
                                {inquiryInfo.productStatus == 'pending' && <Form className='px-1 mt-2' onSubmit={formik.handleSubmit}>
                                    <div style={{ width: '100%', position: 'relative' }}>
                                        <div style={{ marginBottom: '20px' }}>
                                            <Input
                                                maxLength={inputMax}
                                                value={formik.values.remarks}
                                                type='textarea'
                                                name='remarks'
                                                id='remarks'
                                                placeholder='Enter your query/comments'
                                                rows='3'
                                                onChange={formik.handleChange}
                                                style={{
                                                    minHeight: '80px',
                                                    borderRadius: '8px',
                                                    padding: '10px',
                                                    resize: 'none',
                                                    width: '100%',
                                                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                                }}
                                                className={`${formik.touched.remarks && formik.errors.remarks ? 'is-invalid' : ''}`}
                                            />
                                        </div>
                                        <div style={{ position: 'absolute', bottom: '8px', right: '10px' }}>
                                            <Button
                                                disabled={isBtnLoading}
                                                type='submit'
                                                color='success'
                                                style={{ padding: '8px', borderRadius: '50%', width: '40px', height: '40px' }}
                                            >
                                                {isBtnLoading && <span className='spinner-border spinner-border-sm mr-1'></span>}
                                                <i className='bx bx-send'></i>
                                            </Button>

                                        </div>
                                        {formik.touched.remarks && formik.errors.remarks ? (
                                            <FormFeedback className='d-block text-danger' style={{ position: 'absolute', bottom: '-20px', left: '10px' }}>
                                                {formik.errors.remarks}
                                            </FormFeedback>
                                        ) : null}
                                    </div>

                                </Form>}
                                <div style={{
                                    height: inquiryInfo.productStatus == 'pending' ? '450px' : 'auto',
                                    overflowY: 'scroll',
                                }}>
                                    {!isEmpty(inquiryInfo?.remarks) ? inquiryInfo?.remarks.map((item, index) => {
                                        return (
                                            <div key={uuidv4()}
                                                className={`d-flex align-items-center ${item.addedBy === 'user' ? 'justify-content-end ' : 'justify-content-start'} mb-3 px-0`}
                                            >
                                                <Col md={7}>
                                                    <span className='mb-0 font-weight-bold'>
                                                        <strong className='font-weight-bold'>{item.user}</strong>
                                                    </span>
                                                    <Card style={item.addedBy === 'user' ? bgStyle : bgStyleReply}>
                                                        <CardBody className='py-0 px-3 m-0 py-2'>
                                                            <CardText>
                                                                <ProductDescription desc={item.remarks} />
                                                                <span className='text-sm text-end d-block font-italic'>{!isEmpty(item.createdAt) ? moment(item.createdAt).format('MMM DD, YYYY hh:mm A') : ''}</span>
                                                            </CardText>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                            </div>
                                        )
                                    }) :
                                        (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <p className='mb-0'>No communication found</p>
                                            </div>
                                        )
                                    }
                                </div>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ToastDialog
                message={toastInfo.message || ""}
                showToast={toastInfo.showToast}
                role={toastInfo.role}
                onCloseFn={() => setToastInfo({ showToast: false })}
            ></ToastDialog>
            {confirmationStatus && (
                <ConfirmationModal show={confirmationStatus} handleClose={() => setConfirmationStatus(null)} handleSubmit={() => handleStatusChange(confirmationStatus)} text={'Sure, you want to close this inquiry ?'} submitButtonText="Yes" closeButtonText="No" />
            )}
        </React.Fragment>
    )
}

export default EditUserInquiry